import React from "react";
import styled from "styled-components";

const Entry = ({ settings, content, links }) => <div>Entry Template</div>;

export default Entry;
